import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import BASE_URL from "../../config/config";
import ArticlesPage from "./ArticlesPage"; // از کامپوننت موجود استفاده می‌کنیم

export default function TaggedArticlesPage() {
  const { tag } = useParams(); // مثل /blog/tags/python
  const [tagName, setTagName] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTagInfo = async () => {
      try {
        const response = await fetch(`${BASE_URL}/blog/tags/slug/${tag}`, {
          credentials: "include",
        });

        if (response.ok) {
          const result = await response.json();
          setTagName(result.data.name);
        } else {
          setTagName(tag); // اگر نام پیدا نشد، از slug استفاده کن
        }
      } catch (err) {
        setTagName(tag);
      } finally {
        setLoading(false);
      }
    };

    fetchTagInfo();
  }, [tag]);

  if (loading) {
    return <div>در حال بارگذاری...</div>;
  }

  return (
    <div>
      <header className="py-12 bg-gray-50">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl font-bold text-[#140a46]">
            مقالات با برچسب: <span className="text-[#00a0dc]">#{tagName}</span>
          </h1>
          <p className="text-gray-600 mt-2">
            تمام مقالاتی که از تگ <strong>#{tagName}</strong> استفاده کرده‌اند
          </p>
        </div>
      </header>

      {/* لیست مقالات با فیلتر تگ */}
      <ArticlesPage tag={tag} />
    </div>
  );
}